import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'footer',
    label: 'Footer',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
